import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import ApprovalOutlet from "../../../components/settings/approvals/Approvals";
import toast from "../../../components/sweetalert/Sweetalert";
import { useQuery } from "@tanstack/react-query";
import axiosaim from "../../../api/axiosaim";

const Departmental = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const segments = location.pathname.split('/').filter(Boolean);
    const queryParams = new URLSearchParams(location.search);
    
    const aimtoken = sessionStorage.getItem('aimtoken') || '';
    const uname = sessionStorage.getItem('uname') || ''; 
    
    const department = queryParams.get('label');
    const departmentslug = segments?.[2];
    
    const [employeeUname, setEmployeeUname] = useState('all');
    
    const { data: manageddepartments } = useQuery({
        queryKey: ['managedAIMDepartments', uname],
        queryFn: async () => {
            const res = await axiosaim.get(`getmanageddepartments`, {
                headers: { 'X-Aim-Token': aimtoken }
            });
            return res.data;
        },
        enabled: !!uname && !!aimtoken,
        retry: 1
    });

    useEffect(() => {
        if (manageddepartments?.length === 0) {
            navigate('/error');
        }
    }, [manageddepartments]);

    const { data: departmentEmployees } = useQuery({
        queryKey: ['currentDepartmentEmployees'],
        queryFn: async () => {
            const res = await axiosaim.get(`getuserlistsperdepartment?d=${departmentslug}`, {
                headers: { 'X-Aim-Token': aimtoken }
            });
            return res.data;
        },
        enabled: !!departmentslug && !!aimtoken
    });
    
    const { data: employees, error: errorEmployees } = useQuery({
        queryKey: ['multipleDepartmentEmployees', {manageddepartments}],
        queryFn: async () => {
            const departmentCodes = manageddepartments?.map(department => department.department_code);
            const commaDelimitedDepartmentCodes = departmentCodes.join(',');
            const res = await axiosaim.get(`getuserlistsperdepartment?d=${commaDelimitedDepartmentCodes}`, {
                headers: { 'X-Aim-Token': aimtoken }
            });
            return res.data;
        },
        enabled: !!manageddepartments && !!aimtoken
    });
    
    useEffect(() => {
        if (errorEmployees) {
            toast.fire({ icon: 'error', title: 'No user(s) found.' });
        }
    }, [errorEmployees]);

    return (
        <div className="approvals">
            <div className="page-header">
                <div className="title">
                    <h1>Approvals</h1>
                    <ul className="breadcrumbs">
                        <li>
                            <NavLink to="/settings/devices">Settings</NavLink>
                        </li>
                        <li>
                            <NavLink to="/settings/approvals">Approvals</NavLink>
                        </li>
                        <li>
                            <span>{department}</span>
                        </li>
                        {departmentEmployees?.length > 0 && (  
                            <li>                                  
                                <select onChange={(e) => { setEmployeeUname(e.target.value) }}>
                                    <option value="all">All</option>
                                    {departmentEmployees?.length > 0 ? (
                                        departmentEmployees.map((item) => (
                                            <option key={item.uname} value={item.uname}>
                                                {item.fname} {item.lname}
                                            </option>
                                        ))
                                    ) : (
                                        <option value="">--</option>
                                    )}
                                </select>
                            </li>
                        )}
                    </ul>
                </div>
            </div>

            <ApprovalOutlet departmentname={department} departmentslug={departmentslug} employeeUname={employeeUname} />
        </div>
    )
}

export default Departmental;